import { SourceMimeTypes } from '../adapters/video-js/enums/source-mime-types';
import { MediaSourceType, StreamingMediaSource } from '../models';
import { ExtensionsMimeTypeMap } from './enums';

export class MimeTypeProvider {

    static fromExtension(filename: string): SourceMimeTypes {
        const extension: string = filename.split('?').shift().split('.').pop().toLowerCase();
        if (extension in ExtensionsMimeTypeMap) {
            return ExtensionsMimeTypeMap[extension];
        }
    }

    static fromMediaSourceType(ms: MediaSourceType): SourceMimeTypes {
        if (ms) {
            if (ms in SourceMimeTypes) {
                return SourceMimeTypes[ms];
            }
        }
    }

    static getMimeType(ms: StreamingMediaSource): SourceMimeTypes {
        let mime: SourceMimeTypes = MimeTypeProvider.fromMediaSourceType(ms.type);
        if (!mime) {
            mime = MimeTypeProvider.fromExtension(ms.file);
        }
        return mime;
    }

}
